import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Vendors } from "app/_models/vendors";
import { CrudVendorService } from "app/_services/MasterCrudOps/crud-vendor.service";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { EditvendorComponent } from "./editvendor/editvendor.component";
import { AddVenderComponent } from "./add-vender/add-vender.component";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { UserModel } from "app/_models/user-model";
declare const swal: any;

@Component({
  selector: "app-vender",
  templateUrl: "./vender.component.html"
  
})
export class VenderComponent implements OnInit, AfterViewInit {
  currentUser: UserModel;
  isAdminGroupUser: boolean = false;
  vendors: Vendors[];
  totalresultDetails: Vendors[];
  displayedColumns: string[] = [
    "icon",
    "vendorCode",
    "vendorName",
    "description",
    "address",
    "emailIds",
    "contactNumbers",
    "edit",
    "delete"
  ];
  dataSource = new MatTableDataSource<Vendors>([]);
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  editVendor: Vendors;
  pageEvent: PageEvent;

  constructor(
    public datepipe: DatePipe,
    private readonly _liveAnnouncer: LiveAnnouncer,
    private readonly matDialog: MatDialog,
    private readonly crudVendorService: CrudVendorService,
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit(): void {
    this.isLoaderResult = true;
    this.dataSource = new MatTableDataSource<Vendors>(this.vendors); 
    this.vendors = [];
    this.pageSize  = 25;
    this.getVendors(1, this.pageSize, false);
    this.isLoaderResult = false;
  }

  ngAfterViewInit() {
     if (this.dataSource) {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  }

  openDialog() {
    const dialogRef = this.matDialog.open(AddVenderComponent, {
      width: "800px",
      disableClose: false,
      data: {pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getVendors(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.

    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  updateVendor(e, element): void {
    this.editVendor = JSON.parse(JSON.stringify(element));;
    const dialogRef = this.matDialog.open(EditvendorComponent, {
      width: "800px",
      disableClose: true,
      data: {  vendor:this.editVendor,   pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status)
      {
        this.getVendors(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }

  softDelete(e, element) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteVendor(e, element);
      }
    });
  }

  deleteVendor(e, element): void {
    this.isLoaderResult = true;
    this.crudVendorService
      .deleteVendor(element.vendorCode)
      .subscribe((data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message + "\n" + data.additionalMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.getVendors((this.paginator.pageIndex+1), this.paginator.pageSize, false);
        }
      });
    this.isLoaderResult = false;
  }

getVendors(pageNumber: number, currPageSize: number, hasDownloadAllData: boolean) {
  this.isLoaderResult = true; // ✅ Moved here
  const model = {
    currentPage: pageNumber,
    pageSize: currPageSize,
    downloadAllData: hasDownloadAllData,
    stateId: 0
  };

  this.crudVendorService.getPagedActiveVendors(model).subscribe(
    (data) => {
      this.isLoaderResult = false; // ✅ Only here, not earlier

      if (!data.didError) {
        this.vendors = data.model || [];
        this.dataSource = new MatTableDataSource<Vendors>(this.vendors);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.totalRows = data.totalRecords;
        this.resultLength = this.vendors.length;
      } else {
        this.vendors = [];
        swal({
          title: "",
          text: data.message,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    },
    (error) => {
      this.isLoaderResult = false;
      swal({
        title: "",
        text: "Something went wrong. Please contact admin.",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    }
  );
}

  downloadAllRecords()
  {
    swal({
      title: "Are you sure to do this?",
      text: "This process does not display data. It will download all records in a spreadsheet.",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Download the records.",
    }).then((result) => {
      if (result === true) {
        this.isLoaderResult = true;
        let model = {
          currentPage:0,
          pageSize:0,
          downloadAllData:true,
          stateId: 0
        };
       this.crudVendorService
           .getPagedActiveVendors(model)
           .subscribe(
          (results) => {
          this.isLoaderResult = false;
          if (!results.didError) {
            this.totalresultDetails = results.model;
            const workSheet = XLSX.utils.json_to_sheet(
              this.totalresultDetails.map((item) => {
                return {
                  VendorCode: item.vendorCode,
                  VendorName: item.vendorName,
                  Description: item.description,
                  Address: item.address,
                  EmailIds: item.emailIds,
                  ContactNumbers: item.contactNumbers
                };
              })
            );
            const workBook: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
            let fileName =
                          "Vendors_" +
                          this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
                          ".xlsx";
            XLSX.writeFile(workBook, fileName);
          } else {
            this.isLoaderResult = false;
            swal({
              title: "",
              text: results.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        },
        (error) => {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: "Somthing went wrong. Please contact admin",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
      }
    });
  }

 applyFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }
  
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getVendors((this.paginator.pageIndex+1), this.paginator.pageSize, false);
  }
}
